// The curated "packages" shown on the gallery landing — a small, hand-picked
// set of themed collections that replaces the old wall of every tag. This is
// purely editorial (which packages to feature, in what order); membership is
// never listed by hand — each collection is backed by a single tag, so its
// members are auto-derived from the catalogue and a new model joins a package
// simply by carrying that tag (see CLAUDE.md: tags are the open vocabulary, the
// set must not drift).

export interface Collection {
  /** Stable id, used in the `#tag=…` route. */
  id: string;
  /** Display name on the tile. */
  label: string;
  /** The backing tag; the package's members are every model carrying it. */
  tag: string;
  /** One-line description shown under the title. */
  blurb: string;
}

export const COLLECTIONS: Collection[] = [
  { id: "buildings", label: "Buildings", tag: "building", blurb: "Houses, workshops, mills and monuments." },
  { id: "animals",   label: "Animals",   tag: "creature", blurb: "Wildlife, livestock, birds and bugs." },
  { id: "military",  label: "Military",  tag: "military", blurb: "Walls, towers, siege engines and troops." },
  { id: "water",     label: "Water",     tag: "water",    blurb: "Aquatic life, boats and waterside builds." },
  { id: "scenery",   label: "Scenery",   tag: "scenery",  blurb: "Rocks, plants, resources and clutter." },
  { id: "trees",     label: "Trees",     tag: "tree",     blurb: "Every tree and shrub in the set." },
  { id: "vehicles",  label: "Vehicles",  tag: "vehicle",  blurb: "Carts, boats and trucks." },
  // A cross-cutting package: not a domain but a provenance — every model the
  // Fable AI generated (the "v2" style), carrying the `fable` tag.
  { id: "fable",     label: "Fable models", tag: "fable",  blurb: "Models generated by Anthropic's Fable AI model." },
];
